/* tslint:disable */
/* eslint-disable */
/**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiFavoritesIdsGet200Response } from '../models';
/**
 * FavoritesApi - axios parameter creator
 * @export
 */
export const FavoritesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get favorites matches by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFavoritesGet: async (ids: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('apiFavoritesGet', 'ids', ids)
            const localVarPath = `/api/favorites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get favorites matches by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFavoritesIdsGet: async (ids: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('apiFavoritesIdsGet', 'ids', ids)
            const localVarPath = `/api/favorites/{ids}`
                .replace(`{${"ids"}}`, encodeURIComponent(String(ids)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FavoritesApi - functional programming interface
 * @export
 */
export const FavoritesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FavoritesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get favorites matches by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFavoritesGet(ids: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiFavoritesIdsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFavoritesGet(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FavoritesApi.apiFavoritesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get favorites matches by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFavoritesIdsGet(ids: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiFavoritesIdsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFavoritesIdsGet(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FavoritesApi.apiFavoritesIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FavoritesApi - factory interface
 * @export
 */
export const FavoritesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FavoritesApiFp(configuration)
    return {
        /**
         * Get favorites matches by ids
         * @param {FavoritesApiApiFavoritesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFavoritesGet(requestParameters: FavoritesApiApiFavoritesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiFavoritesIdsGet200Response> {
            return localVarFp.apiFavoritesGet(requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Get favorites matches by ids
         * @param {FavoritesApiApiFavoritesIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFavoritesIdsGet(requestParameters: FavoritesApiApiFavoritesIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiFavoritesIdsGet200Response> {
            return localVarFp.apiFavoritesIdsGet(requestParameters.ids, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiFavoritesGet operation in FavoritesApi.
 * @export
 * @interface FavoritesApiApiFavoritesGetRequest
 */
export interface FavoritesApiApiFavoritesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FavoritesApiApiFavoritesGet
     */
    readonly ids: string
}

/**
 * Request parameters for apiFavoritesIdsGet operation in FavoritesApi.
 * @export
 * @interface FavoritesApiApiFavoritesIdsGetRequest
 */
export interface FavoritesApiApiFavoritesIdsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FavoritesApiApiFavoritesIdsGet
     */
    readonly ids: string
}

/**
 * FavoritesApi - object-oriented interface
 * @export
 * @class FavoritesApi
 * @extends {BaseAPI}
 */
export class FavoritesApi extends BaseAPI {
    /**
     * Get favorites matches by ids
     * @param {FavoritesApiApiFavoritesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */
    public apiFavoritesGet(requestParameters: FavoritesApiApiFavoritesGetRequest, options?: RawAxiosRequestConfig) {
        return FavoritesApiFp(this.configuration).apiFavoritesGet(requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get favorites matches by ids
     * @param {FavoritesApiApiFavoritesIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */
    public apiFavoritesIdsGet(requestParameters: FavoritesApiApiFavoritesIdsGetRequest, options?: RawAxiosRequestConfig) {
        return FavoritesApiFp(this.configuration).apiFavoritesIdsGet(requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }
}

